"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayrollProvider = void 0;
var PayrollProvider;
(function (PayrollProvider) {
    PayrollProvider["ADP_RUN"] = "ADP_RUN";
    PayrollProvider["ADP_WORKFORCE_NOW"] = "ADP_WORKFORCE_NOW";
    PayrollProvider["CERIDIAN_DAYFORCE"] = "CERIDIAN_DAYFORCE";
    PayrollProvider["GUSTO"] = "GUSTO";
    PayrollProvider["JUSTWORKS"] = "JUSTWORKS";
    PayrollProvider["PAYCHEX_FLEX"] = "PAYCHEX_FLEX";
    PayrollProvider["PAYLOCITY"] = "PAYLOCITY";
    PayrollProvider["QUICKBOOKS"] = "QUICKBOOKS";
    PayrollProvider["RIPPLING"] = "RIPPLING";
    PayrollProvider["TRINET"] = "TRINET";
    PayrollProvider["WORKDAY"] = "WORKDAY";
    PayrollProvider["ZENEFITS"] = "ZENEFITS";
    PayrollProvider["SELF_REPORTED"] = "SELF_REPORTED";
})(PayrollProvider || (exports.PayrollProvider = PayrollProvider = {}));
